import React, { useContext } from "react"
import Spinner from "../components/elements/Spinner"
import TextBook, { TextBookKeys } from "../components/Textbook"
import { Context } from "../store/store"
import { Link } from "react-router-dom"
import ScrollParentToTop from "../components/ScrollParentToTop"

function Thankyou() {
	const { globalState } = useContext(Context)

	return (
		<div>
			<ScrollParentToTop />
			{globalState.strapi.homepage ? (
				<>
					<div className="relative  grid bg-[url('/src/bgimages/bg-won-mobile.png')] sm:bg-[url('/src/bgimages/bg-won-desktop.png')] bg-cover h-[80vh] bg-no-repeat bg-center max-w-[1800px] mx-auto">
						<div className="grid sm:grid-cols-[70%_30%] max-w-[1324px]  mx-auto gap-4 px-4 justify-items-center items-center self-center justify-self-center">
							<div className="text-left max-w-[1300px] pt-32 md:pt-0 ">
								<h1 className="text-white">Vielen Dank fürs Mitmachen</h1>
								<p className="text-white">Deine Teilnahme wurde erfolgreich übermittelt. Wir prüfen nun Deinen Kassenbon und bearbeiten 
									Deine Rückerstattung. Bitte habe etwas Geduld – die Prüfung kann einige Werktage in Anspruch nehmen.In der Zwischenzeit wünschen wir Dir viel Spaß mit der natürlich leckeren Energie von TREK!</p>
									<div className=" grid grid-cols-2 md:flex  items-center gap-x-2 md:gap-x-6 mt-6 lg:mt-12  ">
											<a href="https://www.trekbars.com/" className="btn btn-primary justify-self-center" target="_blank" rel="noopener noreferrer">
												Zur Trek Website
											</a>
											<Link to="/" className="btn btn-secondary-transparent justify-self-center bg-transparent">
												zurück zu Aktion
											</Link>
										</div>
							</div>
							<div>
								
							</div>
						</div>
					</div>
				</>
			) : (
				<div className="py-20 text-center">
					<Spinner />
					<TextBook textKey={TextBookKeys.HOMEPAGE} />
				</div>
			)}
		</div>
	)
}

export default Thankyou
